import React, { useState, useEffect } from 'react';
import './GeofenceNamingModal.css';

const GeofenceNamingModal = ({ isOpen, onClose, onSave, geofenceData }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setName('');
      setDescription('');
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!name.trim()) {
      alert('Please enter a name for the geofence');
      return;
    }

    setIsLoading(true);
    try {
      await onSave({
        ...geofenceData,
        name: name.trim(),
        description: description.trim()
      });
      onClose();
    } catch (error) {
      console.error('Error saving geofence:', error);
      alert('Error saving geofence. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="geofence-modal-overlay">
      <div className="geofence-modal">
        <div className="geofence-modal-header">
          <h3>Name Your Geofence</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="geofence-modal-body">
          <div className="form-group">
            <label htmlFor="geofence-name">Geofence Name *</label>
            <input
              id="geofence-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter geofence name..."
              maxLength={50}
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="geofence-description">Description (Optional)</label>
            <textarea
              id="geofence-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
              maxLength={200}
              rows={3}
              disabled={isLoading}
            />
          </div>
          
          <div className="geofence-info">
            <p><strong>Vertices:</strong> {geofenceData?.coordinates?.length || 0}</p>
            <p><strong>Type:</strong> Custom Geofence</p>
          </div>
        </div>
        
        <div className="geofence-modal-footer">
          <button 
            className="cancel-button" 
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            className="save-button" 
            onClick={handleSave}
            disabled={isLoading || !name.trim()}
          >
            {isLoading ? 'Saving...' : 'Save Geofence'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeofenceNamingModal;
